import styled from 'styled-components';

import FullScreenSpinner from 'components/FullScreenSpinner';

export const SpinnerDef = styled(FullScreenSpinner)`
  flex: 0 1 auto;
  margin: 10px 0;
`;
